(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4346],{

/***/ 11869:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[slug]",
      function () {
        return __webpack_require__(19838);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cookies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50921);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);




function Cookies(props) {
    if (props.showPolicy) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            id: "cookies",
            className: "fixed w-full bottom-0 z-50 p-3 mb-0 bg-slate-400 flex justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    onClick: function() {
                        return props.setShowPolicy(false);
                    },
                    className: "mx-3 text-white hover:text-slate-300",
                    style: {
                        fontSize: 25
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-white text-center mb-0",
                    children: [
                        "By using this site, you agree to our",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/cookie-policy",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-white",
                                    children: " Cookie Policy "
                                })
                            })
                        }),
                        "and",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/privacy-policy",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-white",
                                    children: " Privacy Policy"
                                })
                            })
                        })
                    ]
                })
            ]
        }));
    }
    return null;
};


/***/ }),

/***/ 93674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(33587);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js
var MenuIcon = __webpack_require__(69065);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./contexts/Auth.js
var Auth = __webpack_require__(92842);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next-intercom/dist/index.js
var dist = __webpack_require__(33854);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(52500);
// EXTERNAL MODULE: ./components/Cookies.js
var Cookies = __webpack_require__(36076);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
;// CONCATENATED MODULE: ./components/Layouts/Navbars/HomeNav.js













var navigation = [
    // { name: 'Product', href: '#' },
    {
        name: 'AI Generator',
        href: '/ai-tools'
    },
    {
        name: 'Directory',
        href: '/directory'
    },
    {
        name: 'Guides',
        href: '/guides'
    },
    {
        name: 'Blog',
        href: '/blog'
    }, 
];
function HomeNav() {
    var ref = (0,Auth/* useAuth */.a)(), user = ref.user, signOut = ref.signOut;
    var ref1 = (0,react.useState)(false), showPolicy = ref1[0], setShowPolicy = ref1[1];
    (0,react.useEffect)(function() {
        if (!config/* dev */.WI && user) {
            (0,dist.loadIntercom)({
                appId: 'zpntjk45',
                name: "",
                email: user ? user.email : "",
                ssr: false,
                initWindow: true,
                delay: 2000
            });
        } else if (!config/* dev */.WI) {
            (0,dist.loadIntercom)({
                appId: 'zpntjk45',
                ssr: false,
                initWindow: true,
                delay: 2000
            });
        }
        var cook = (0,lib.getCookie)("policy");
        if (!cook) {
            setShowPolicy(true);
            (0,lib.setCookie)("policy", "true");
        }
    }, [
        user
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        as: "header",
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cookies/* default */.Z, {
                showPolicy: showPolicy,
                setShowPolicy: setShowPolicy
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-slate-200/50 pt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: "relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6",
                    "aria-label": "Global",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center flex-1 justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full md:w-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Plaza"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                        alt: "Plaza Logo",
                                                        src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-logto-tail.png",
                                                        width: 128,
                                                        height: 64,
                                                        objectFit: "contain"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "-mr-2 flex items-center md:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                className: "bg-gray-900 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-800 focus:outline-none focus:ring-2 focus-ring-inset focus:ring-white",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open main menu"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden space-x-8 md:!flex md:ml-10 md:mr-10",
                                    children: navigation.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: item.href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-base font-medium text-slate-500 hover:text-gray-800",
                                                children: item.name
                                            })
                                        }, item.name);
                                    })
                                })
                            ]
                        }),
                        user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:!flex md:items-center md:space-x-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center text-base font-medium text-gray-600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return signOut();
                                        },
                                        className: "text-gray-900 hover:underline",
                                        children: "Logout"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/dashboard",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                        children: "Dashboard"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:!flex md:items-center md:space-x-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-base font-medium text-slate-900 hover:text-gray-600",
                                        children: "Log in"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/#bookDemo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                        children: "Book a Demo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                as: react.Fragment,
                enter: "duration-150 ease-out",
                enterFrom: "opacity-0 scale-95",
                enterTo: "opacity-100 scale-100",
                leave: "duration-100 ease-in",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-95",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                    focus: true,
                    className: "absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-5 pt-4 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            alt: "Plaza",
                                            src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-logto-tail.png",
                                            width: 128,
                                            height: 64,
                                            objectFit: "contain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "-mr-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                            className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-fuchsia-600",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                    className: "h-6 w-6",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-5 pb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-2 space-y-1",
                                        children: navigation.map(function(item) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: item.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50",
                                                    children: item.name
                                                })
                                            }, item.name);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6 px-5",
                                        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: "/dashboard",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "block text-center w-full py-3 px-4 rounded-md shadow shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-900",
                                                        children: "Dashboard"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-center mt-4 text-base font-medium text-gray-600",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: function() {
                                                            return signOut();
                                                        },
                                                        className: "text-gray-900 hover:underline",
                                                        children: "Logout"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-6 px-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "/#bookDemo",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "block text-center w-full py-3 px-4 rounded-md shadow shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-900",
                                                            children: "Book a Demo"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-center text-base font-medium text-gray-600",
                                                    children: [
                                                        "Existing customer?",
                                                        ' ',
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                            href: "/login",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "text-gray-900 hover:underline",
                                                                children: "Login"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
;// CONCATENATED MODULE: ./components/Layouts/homeLayout.js



var Footer = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 3474).then(__webpack_require__.bind(__webpack_require__, 73193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73193)
            ];
        }
    }
});
function Layout(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNav, {}),
            children
        ]
    }));
};


/***/ }),

/***/ 18549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);


//Could use a package called next-seo
function Meta(param) {
    var title = param.title, description = param.description, image = param.image, url = param.url;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    charSet: "utf-8"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "icon",
                    href: "/favicon.ico"
                }),
                url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: url
                        }, "canonical"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:url",
                            content: url
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "website"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: "https://plaza.so/"
                }),
                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: image
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: title
                })
            ]
        })
    }));
};


/***/ }),

/***/ 19838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ ArticleSlug; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4143);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86994);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52500);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var _components_Layouts_homeLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93674);
/* harmony import */ var _contexts_Auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92842);
/* harmony import */ var _components_Notification__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96691);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19412);
/* harmony import */ var _components_Meta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18549);
/* harmony import */ var chart_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53328);
/* harmony import */ var react_chartjs_2__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55376);













function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
chart_js__WEBPACK_IMPORTED_MODULE_10__/* .Chart.register */ .kL.register(chart_js__WEBPACK_IMPORTED_MODULE_10__/* .CategoryScale */ .uw, chart_js__WEBPACK_IMPORTED_MODULE_10__/* .LinearScale */ .f$, chart_js__WEBPACK_IMPORTED_MODULE_10__/* .PointElement */ .od, chart_js__WEBPACK_IMPORTED_MODULE_10__/* .LineElement */ .jn, chart_js__WEBPACK_IMPORTED_MODULE_10__/* .Title */ .Dx, chart_js__WEBPACK_IMPORTED_MODULE_10__/* .Tooltip */ .u, chart_js__WEBPACK_IMPORTED_MODULE_10__/* .Legend */ .De, chart_js__WEBPACK_IMPORTED_MODULE_10__/* .Filler */ .Gu);
var __N_SSG = true;
function ArticleSlug(param) {
    var article = param.article;
    var ref, ref1;
    var promptArr = [
        {
            intro: "What does a ".concat(article.id < 34 ? "virtual" : "", " ").concat(article.vertical, " coach do?")
        },
        {
            how: "How to become a ".concat(article.id < 34 ? "virtual" : "", " ").concat(article.vertical, " coach?")
        },
        {
            certs: "Certifications to pursue ".concat(article.id < 34 ? "virtual" : "", " ").concat(article.vertical, " coaching")
        },
        {
            fbGroups: "What facebook groups should a ".concat(article.id < 34 ? "virtual" : "", " ").concat(article.vertical, " coaching follow?")
        },
        {
            grow: "How to grow as a ".concat(article.id < 34 ? "virtual" : "", " ").concat(article.vertical, " coach?")
        },
        {
            targets: "Who should a ".concat(article.vertical, " coach target for their services?")
        },
        {
            things: "Things to remember as a ".concat(article.id < 34 ? "virtual" : "", " ").concat(article.vertical, " coach")
        }
    ];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-87fa3bbf602a6226" + " " + "bg-slate-200/50 h-full pt-5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Meta__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                title: "How to Become an Online ".concat(article.vertical.charAt(0).toUpperCase() + article.vertical.slice(1), " Coach"),
                description: article.intro.slice(0, 155)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-87fa3bbf602a6226" + " " + " text-left overflow-hidden bg-slate-200/80 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-87fa3bbf602a6226" + " " + "mt-20 text-slate-400 font-bold  mx-auto w-3/4  rounded-lg hover:text-slate-800",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                            href: "/guides/coach",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "jsx-87fa3bbf602a6226" + " " + "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-87fa3bbf602a6226" + " " + "text-slate-400 hover:text-slate-700 text-base font-semibold",
                                        children: "Return to Guide"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "jsx-87fa3bbf602a6226" + " " + "font-extrabold  text-4xl w-3/4 mx-auto pt-4 pb-20 text-slate-800 font-serif ",
                        children: [
                            "How to Become an Online ",
                            article.vertical.charAt(0).toUpperCase() + article.vertical.slice(1),
                            " Coach"
                        ]
                    }),
                    article.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-87fa3bbf602a6226",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            alt: "How to Become an online dating coach",
                            controls: true,
                            className: "jsx-87fa3bbf602a6226" + " " + "w-[90%] sm:w-1/2 mx-auto rounded-lg aspect-video mb-20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                src: "".concat(_config__WEBPACK_IMPORTED_MODULE_3__/* .cloudfront */ .bG, "/media/stock_videos/").concat(article.video),
                                type: "video/mp4",
                                className: "jsx-87fa3bbf602a6226"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "aria-hidden": "true",
                className: "jsx-87fa3bbf602a6226" + " " + "absolute  h-full w-full overflow-hidden z-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-87fa3bbf602a6226" + " " + "relative h-full overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                            width: 404,
                            height: 784,
                            fill: "none",
                            viewBox: "0 0 404 784",
                            className: "jsx-87fa3bbf602a6226" + " " + "absolute right-full transform translate-y-1/3 translate-x-1/4 md:translate-y-1/2 sm:translate-x-1/2 lg:translate-x-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                    className: "jsx-87fa3bbf602a6226",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pattern", {
                                        id: "e229dbec-10e9-49ee-8ec3-0286ca089edf",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        className: "jsx-87fa3bbf602a6226",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            fill: "currentColor",
                                            className: "jsx-87fa3bbf602a6226" + " " + "text-gray-200"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                    width: 404,
                                    height: 784,
                                    fill: "url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)",
                                    className: "jsx-87fa3bbf602a6226"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                            width: 404,
                            height: 784,
                            fill: "none",
                            viewBox: "0 0 404 784",
                            className: "jsx-87fa3bbf602a6226" + " " + "absolute left-full transform -translate-y-3/4 -translate-x-1/4 sm:-translate-x-1/2 md:-translate-y-1/2 lg:-translate-x-3/4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                    className: "jsx-87fa3bbf602a6226",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pattern", {
                                        id: "d2a68204-c383-44b1-b99f-42ccff4e5365",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        className: "jsx-87fa3bbf602a6226",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            fill: "currentColor",
                                            className: "jsx-87fa3bbf602a6226" + " " + "text-gray-200"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                    width: 404,
                                    height: 784,
                                    fill: "url(#d2a68204-c383-44b1-b99f-42ccff4e5365)",
                                    className: "jsx-87fa3bbf602a6226"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-87fa3bbf602a6226" + " " + "lg:mx-20 mx-4 pt-10 text-left pb-48 z-20 relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-87fa3bbf602a6226" + " " + "flex md:flex-row flex-col justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-87fa3bbf602a6226" + " " + "space-y-12 w-full md:w-2/3",
                                children: [
                                    article.content ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            whiteSpace: "pre-wrap"
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: article.content
                                        },
                                        className: "jsx-87fa3bbf602a6226" + " " + "text-slate-800 text-lg mx-auto sm:w-3/4"
                                    }) : promptArr.map(function(obj) {
                                        return Object.keys(obj)[0];
                                    }).map(function(key, index) {
                                        return article[key] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-87fa3bbf602a6226" + " " + "mx-auto sm:w-3/4",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "jsx-87fa3bbf602a6226" + " " + "text-slate-800 font-bold text-2xl",
                                                    children: promptArr[index][key]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    style: {
                                                        whiteSpace: "pre-line"
                                                    },
                                                    className: "jsx-87fa3bbf602a6226" + " " + "text-xl text-slate-700 -mt-12",
                                                    children: article[key]
                                                })
                                            ]
                                        }, "topic-".concat(index));
                                    }),
                                    article.directory_link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-87fa3bbf602a6226" + " " + "mx-auto sm:w-3/4 text-slate-700",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "jsx-87fa3bbf602a6226" + " " + "mb-4 font-bold text-2xl text-slate-800",
                                                children: "Conclusion"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "jsx-87fa3bbf602a6226",
                                                children: [
                                                    "We hope this helps kickstart your journey towards becoming a ",
                                                    article.vertical,
                                                    " coach.  Check out our  ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                        href: "/coaches/".concat(article.directory_link),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            className: "jsx-87fa3bbf602a6226" + " " + "underline font-semibold",
                                                            children: " directory"
                                                        })
                                                    }),
                                                    " ",
                                                    "if you are looking for more inspiration or just need some examples of successful ",
                                                    article.vertical,
                                                    " coaches."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-87fa3bbf602a6226" + " " + "w-full md:w-1/3",
                                children: [
                                    article.trend_data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "jsx-87fa3bbf602a6226" + " " + "text-slate-800 font-bold text-2xl mt-[38px] mb-5",
                                                children: "Analytics"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-87fa3bbf602a6226" + " " + "bg-slate-200 p-2 rounded-md",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_chartjs_2__WEBPACK_IMPORTED_MODULE_12__/* .Line */ .x1, {
                                                        datasetIdKey: "id",
                                                        data: {
                                                            labels: (ref = article.trend_data) === null || ref === void 0 ? void 0 : ref.map(function(obj) {
                                                                return obj.formattedTime;
                                                            }),
                                                            datasets: [
                                                                {
                                                                    id: 1,
                                                                    label: "Interest for ".concat(article.vertical.charAt(0).toUpperCase() + article.vertical.slice(1), " Coach over time"),
                                                                    data: (ref1 = article.trend_data) === null || ref1 === void 0 ? void 0 : ref1.map(function(obj) {
                                                                        return obj.value[0];
                                                                    }),
                                                                    borderColor: 'rgb(192, 38, 211)',
                                                                    backgroundColor: 'rgba(243, 167, 252, 0.5)',
                                                                    fill: {
                                                                        target: 'origin',
                                                                        below: 'rgb(192, 38, 211)' // And blue below the origin
                                                                    }
                                                                }, 
                                                            ]
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-87fa3bbf602a6226" + " " + "text-sm italic mt-3 text-gray-500",
                                                        children: "*Based on search engine data"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    article.salary_data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-87fa3bbf602a6226" + " " + "bg-slate-200 p-2 mt-10 rounded-md",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "jsx-87fa3bbf602a6226" + " " + "text-sm text-gray-500 text-center mb-1",
                                                children: "Salary Data USD"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                                style: {
                                                    width: "100%",
                                                    color: "#6B7280"
                                                },
                                                className: "jsx-87fa3bbf602a6226" + " " + "table-auto w-full",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                                        className: "jsx-87fa3bbf602a6226" + " " + "border-b border-gray-300",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                            className: "jsx-87fa3bbf602a6226",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                    className: "jsx-87fa3bbf602a6226",
                                                                    children: "Publisher"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                    className: "jsx-87fa3bbf602a6226",
                                                                    children: "Min"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                    className: "jsx-87fa3bbf602a6226",
                                                                    children: "Median"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                    className: "jsx-87fa3bbf602a6226",
                                                                    children: "Max"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                    className: "jsx-87fa3bbf602a6226",
                                                                    children: "Period"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                                        className: "jsx-87fa3bbf602a6226",
                                                        children: article.salary_data.map(function(obj, index) {
                                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                                className: "jsx-87fa3bbf602a6226",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                        className: "jsx-87fa3bbf602a6226",
                                                                        children: obj.publisher_name
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                        className: "jsx-87fa3bbf602a6226",
                                                                        children: Math.round(obj.min_salary)
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                        className: "jsx-87fa3bbf602a6226",
                                                                        children: Math.round(obj.median_salary)
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                        className: "jsx-87fa3bbf602a6226",
                                                                        children: Math.round(obj.max_salary)
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                        className: "jsx-87fa3bbf602a6226",
                                                                        children: obj.salary_period.toLowerCase()
                                                                    })
                                                                ]
                                                            }, "sal-".concat(index));
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-87fa3bbf602a6226" + " " + "bg-white rounded-lg shadow-lg mt-32 border flex flex-col sm:flex-row justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-87fa3bbf602a6226" + " " + "p-10 shadow z-10 w-full sm:w-[60%] text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "jsx-87fa3bbf602a6226" + " " + "text-slate-800 font-bold text-2xl",
                                        children: "Get started today with Plaza"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-87fa3bbf602a6226" + " " + "text-slate-800 text-base",
                                        children: "Everything you need for your virtual coaching business"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-87fa3bbf602a6226" + " " + "flex space-x-3 mt-4 mx-auto w-72 ",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                href: "/",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "jsx-87fa3bbf602a6226" + " " + "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                                    children: "Get Started"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                href: "/",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "jsx-87fa3bbf602a6226" + " " + "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-slate-700 text-white shadow-lg shadow-slate-500/50 bg-slate-600",
                                                    children: "Book a Demo"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-87fa3bbf602a6226" + " " + "my-2 mx-auto text-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                            objectFit: 'contain',
                                            src: "".concat(_config__WEBPACK_IMPORTED_MODULE_3__/* .cloudfront */ .bG, "/static/branding_group.png"),
                                            width: 500,
                                            height: 300,
                                            alt: "Plaza for video consultations"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "jsx-87fa3bbf602a6226" + " " + "space-y-5 p-10 bg-slate-100 w-full sm:w-[40%]",
                                children: _config__WEBPACK_IMPORTED_MODULE_3__/* .features.map */ .R2.map(function(string) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-87fa3bbf602a6226" + " " + "flex justify-start items-center space-x-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-87fa3bbf602a6226" + " " + "",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    className: "bg-green-400 text-white rounded-full"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "jsx-87fa3bbf602a6226" + " " + "text-slate-700 font-semibold text-base",
                                                children: string
                                            }, string)
                                        ]
                                    }, string);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-87fa3bbf602a6226" + " " + "w-full flex justify-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "jsx-87fa3bbf602a6226" + " " + "text-slate-500 text-base",
                    children: "\xa9 2023 Ordinary Media, LLC. All Rights Reserved."
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "87fa3bbf602a6226",
                children: "p>a{text-decoration:underline}\np>a:hover{color:rgb(23, 40, 70)}\np{font-size:1.25rem;\nline-height:1.75rem;\ncolor:rgb(71 85 105)}\nh1{font-size:2em}\nh2{font-size:1.5em}\nh3{font-size:1.17em;\nmargin-top:40px;\nmargin-bottom:5px}"
            })
        ]
    }));
};
var alertOptions = {
    // you can also just use 'bottom right'
    position: react_alert__WEBPACK_IMPORTED_MODULE_8__/* .positions.BOTTOM_RIGHT */ .m7.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: {
        'zIndex': '9999'
    },
    // you can also just use 'fade'
    transition: react_alert__WEBPACK_IMPORTED_MODULE_8__/* .transitions.FADE */ .pB.FADE
};
ArticleSlug.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_alert__WEBPACK_IMPORTED_MODULE_8__/* .Provider */ .zt, _objectSpread({
        template: _components_Notification__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
    }, alertOptions, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_Auth__WEBPACK_IMPORTED_MODULE_6__/* .AuthProvider */ .H, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layouts_homeLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: page
            })
        })
    })));
};


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 4143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var ArrowLeft = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
  }));
});
ArrowLeft.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
ArrowLeft.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowLeft);

/***/ }),

/***/ 86994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Check = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
  }));
});
Check.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
Check.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);

/***/ }),

/***/ 55376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x1": function() { return /* binding */ Line; }
/* harmony export */ });
/* unused harmony exports Bar, Bubble, Chart, Doughnut, Pie, PolarArea, Radar, Scatter, getDatasetAtEvent, getElementAtEvent, getElementsAtEvent */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var chart_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53328);



const defaultDatasetIdKey = 'label';
function reforwardRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref) {
        ref.current = value;
    }
}
function setOptions(chart, nextOptions) {
    chart.options = {
        ...nextOptions
    };
}
function setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]
        );
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
            return {
                ...nextDataset
            };
        }
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    setLabels(nextData, data.labels);
    setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getDatasetAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementsAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
        intersect: true
    }, false);
}

function ChartComponent(param, ref) {
    let { height =150 , width =300 , redraw =false , datasetIdKey , type , data , options , plugins =[] , fallbackContent , ...props } = param;
    const canvasRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const chartRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new chart_js__WEBPACK_IMPORTED_MODULE_1__/* .Chart */ .kL(canvasRef.current, {
            type,
            data: cloneData(data, datasetIdKey),
            options,
            plugins
        });
        reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!redraw && chartRef.current && options) {
            setOptions(chartRef.current, options);
        }
    }, [
        redraw,
        options
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!redraw && chartRef.current) {
            setLabels(chartRef.current.config.data, data.labels);
        }
    }, [
        redraw,
        data.labels
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) {
            setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
        }
    }, [
        redraw,
        data.datasets
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else {
            chartRef.current.update();
        }
    }, [
        redraw,
        options,
        data.labels,
        data.datasets
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart()
        ;
    }, []);
    return(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, props), fallbackContent));
}
const Chart = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ChartComponent);

function createTypedChart(type, registerables) {
    chart_js__WEBPACK_IMPORTED_MODULE_1__/* .Chart.register */ .kL.register(registerables);
    return(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Chart, Object.assign({}, props, {
            ref: ref,
            type: type
        }))
    ));
}
const Line = /* #__PURE__ */ createTypedChart('line', chart_js__WEBPACK_IMPORTED_MODULE_1__/* .LineController */ .ST);
const Bar = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart('bar', BarController)));
const Radar = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart('radar', RadarController)));
const Doughnut = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart('doughnut', DoughnutController)));
const PolarArea = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart('polarArea', PolarAreaController)));
const Bubble = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart('bubble', BubbleController)));
const Pie = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart('pie', PieController)));
const Scatter = /* #__PURE__ */ (/* unused pure expression or super */ null && (createTypedChart('scatter', ScatterController)));


//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7570,5675,3640,3616,5988,7612,3940,9774,2888,179], function() { return __webpack_exec__(11869); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);